import { render, staticRenderFns } from "./tableAnticipations.vue?vue&type=template&id=5990ca3e"
import script from "./tableAnticipations.vue?vue&type=script&lang=js"
export * from "./tableAnticipations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports